module.exports = __webpack_public_path__ + "media/images/basic_logos/clone-20046f74c87882fd5f30c42f9dbd2b6e.svg";